// extracted by mini-css-extract-plugin
export default {"slideMenu":"SlideMenu_slideMenu__OuELM","menuList":"SlideMenu_menuList__xiC1n"};